import axios from "axios";
import { useDispatch } from "react-redux";
import useAlert from "./useAlert";
import useFetch from "./useFetch";

function blobToText(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsText(blob);
    });
}

const useFileUploader = () => {

    const {topMiddleAlert} = useAlert();
    const {post, get} = useFetch();

    const uploadFiles = async (file, fileName = null, type, type_id, directory, attachment_type) => {
        const formData = new FormData();
        formData.append('file', file, `${fileName == null ? file : fileName}`);
        formData.append(`type_id`, type_id);
        formData.append('type', type);
        formData.append('attachment_type', attachment_type);
        formData.append('directory', `${directory}/${type_id}`);

        const res = await post('agent/upload-attachment', formData, false)
        if(res.status == 'success'){
            console.log(res, 'uploaded');
        }

    }

    const multiUpload = async (files, type, type_id, directory, attachment_type, endpoint, data = {}) => {
        const formData = new FormData();

        files.forEach((file) => {
            formData.append('files[]', file, file.name)
        });
    
        formData.append('type_id', type_id);
        formData.append('type', type);
        formData.append('attachment_type', attachment_type);
        formData.append('directory', `${directory}/${type_id}`);

        if(Object.keys(data).length > 0){
            Object.keys(data).forEach((element) => {
                formData.append(element, data[element]);
            })
        }
    
        const res = await post(endpoint, formData, true)
        if(res.status == 'success'){
            console.log(res, 'uploaded');
        }

        return res;

    }
    
    const retrieveAttachment = async (name, directory, type_id, type) => {
        const data = {
            type_id: type_id,
            file_name: name,
            directory: directory,
            type: 'attachments'
        }
        // const res = await get(`agent/retrieve-attachment?quote_id=${data.quote_id}&file_name=${name}&directory=${directory}`)

        axios.get(`${process.env.NEXT_PUBLIC_BASE_API_URL}agent/retrieve-attachment?type_id=${data.type_id}&file_name=${name}&directory=${directory}`, {
            // headers: { Cookie: req.headers.cookie }, 
            responseType: 'blob',
            withCredentials: true,
        }).then((response) => {
               const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name); //or any other extension
                document.body.appendChild(link);
                link.click();
        })
        .catch(async (error) => {
            if(error.response && error.response.data){
                const errorData = error.response.data;

                if(errorData instanceof Blob){
                    const errorText = await blobToText(errorData);

                    try {
                        const errorObj = JSON.parse(errorText);
                        topMiddleAlert('ERROR', errorObj.message)
                    } catch (error) {
                        topMiddleAlert('ERROR', 'Oops, something went wrong!')
                    }

                }
            }
        });
    }

    const downloadFromBase64 = (name, base64) => {
        // Convert base64 data to a Blob
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'image/jpeg' }); 
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.click();
    
        window.URL.revokeObjectURL(url);
    }

    return {
        uploadFiles, 
        multiUpload,
        retrieveAttachment,
        downloadFromBase64
    }
}

export default useFileUploader;